<template>
   <Forms ref="frmSearch"
           title="PESQUISA POR PRIMEIRO ADIANTAMENTO"
           :showHelp="true"
           :showClearButton="true"
           :showSearchButton="true"
           :showNewButton="false"
           :ShowFooterImbo="true"
           :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
           v-on:Clear="onClearSection"
           v-on:Search="Search"
           >
            <div class="form-group row">

                <label class="label-search">Funcionário</label>
                <autocomplete-z ref="favorecidoTypeahead"
                    placeholder="Digite o nome do Funcionário"
                    iconClass="fas fa-id-badge"
                    :serializer="(favorecido) => favorecido.codigo + ' - ' + favorecido.nome"
                    :debounceLength="3"
                    :formField="form.funcionarioId"
                    :returnCallback="true"
                    v-on:search="onSearchFavorecido"
                    v-on:changeCode="onChangeCodeFavorecido" />

                <label class="label-search">Lote:</label>
                <b-input v-model="form.lote.value" placeholder="Insira o Número do Lote" />

                <div style="width: 100%;">
                    <label class="label-search">Situação:</label>
                    <select v-model="form.situacao.value" class="form-control">
                        <option :value="null">Selecione</option>
                        <option v-for="data in dataStatusDespesa" :key="data.value" :value="data.value">{{data.text}}</option>
                    </select>
                </div>

                <div style="width: 100%;">
                <label class="label-search">Data do Lote</label>
                <input type="date" v-model="form.dataLote.value" class="input-date form-control" />
                </div>

            </div>
   </Forms>
</template>

<script>
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import formdata from '@/views/private/finance/expenses/travelexpensezpag/components/ExpenseSearch/form'
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin.js'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
// import AcceptanceTermRepository from '@/shared/http/repositories/business/acceptanceterm'
// import SectionRHRepository from '@/shared/http/repositories/business/sectionrh'
// import ExpenseRepository from '@/shared/http/repositories/business/expense'
// import { loading } from '@/shared/utils/UIHelper'
export default {
  name: 'ExpenseSearch',
  components: {AutocompleteZ},
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      dataStatusDespesa: [],
      form: {
        lote: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        funcionarioId: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        dataLote: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        },
        situacao: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      formOriginal: {...formdata}
    }
  },
  mounted () {
    this.GetStatusDespesa()
  },
  methods: {
    GetStatusDespesa () {
      TravelExpenseRepository.GetAllStatusDespesas()
        .then((Response) => {
          console.log(Response)
          this.dataStatusDespesa.push(Response.data[2], Response.data[3], Response.data[4], Response.data[5])
        })
        .catch((Error) => {
          console.error(Error)
        })
    },
    Search () {
      localStoreHelper.viagem.primeiroAdiantamento({FuncionarioId: this.form.funcionarioId.value, Lote: this.form.lote.value, Situacao: this.form.situacao.value, DataInclusao: this.form.dataLote.value})
      this.$emit('search', {FuncionarioId: this.form.funcionarioId.value, Lote: this.form.lote.value, Situacao: this.form.situacao.value, DataInclusao: this.form.dataLote.value})
    },
    onClearSection () {
      this.$refs.favorecidoTypeahead.clear()
      this.form.lote.value = null
      this.form.situacao.value = null
      this.form.dataLote.value = null
    }
  }
}
</script>

<style>
.label-search{
    padding-bottom: 0px;
    margin-bottom: 0px;
    margin-top: 10px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelexpensezpag/components/Tabs/AdvanceFirstTrip/components/FilterAdvanceFirstTrip.vue